import isUndefined from 'lodash/isUndefined';
import isDate from 'lodash/isDate';

const isValidDate = date => {
  return isDate(date) && !isNaN(date);
};

export default (from, to) => {
  let fromDate = isUndefined(to) ? new Date() : from;
  let toDate = to || from;
  let seconds = 0;
  let minutes = 0;
  let hours = 0;
  let days = 0;

  if (!(fromDate instanceof Date)) {
    fromDate = new Date(fromDate);
  }
  if (!(toDate instanceof Date)) {
    toDate = new Date(toDate);
  }

  const hasDatePassed = toDate <= fromDate;

  if (!isValidDate(fromDate) || !isValidDate(toDate) || hasDatePassed) {
    return {
      seconds,
      minutes,
      hours,
      days,
    };
  }

  seconds = Math.abs(toDate - fromDate) / 1000;
  minutes = Math.floor(seconds / 60);
  hours = Math.floor(minutes / 60);
  days = Math.floor(hours / 24);

  return {
    seconds,
    minutes,
    hours,
    days,
  };
};


// WEBPACK FOOTER //
// ./src/common/utils/time-between.js